<template>
    <div class="report-website">
        <div class="module-item-style report-filter-container">
            <el-date-picker
                    v-model="selectTime"
                    type="daterange"
                    @change="timeSelect"
                    :picker-options="pickerOptions"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
            >
            </el-date-picker>
            <div class="website-addr-container">
                <el-popover
                        placement="bottom"
                        v-model="popoverVisible"
                        trigger="click">
                    <div class="addr-tree-container">
                        <el-tree
                                :data="treeData"
                                show-checkbox
                                class="addr-tree"
                                node-key="id"
                                ref="tree"
                                highlight-current>
                        </el-tree>
                        <div class="comfirm-btn" @click="chooseAddr">确认</div>
                    </div>
                    <div  class="addr-text" slot="reference" :title="checkedAddrName">{{checkedAddrName}}</div>
                </el-popover>

            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title-border-left">
                访问轨迹数据
            </div>
            <div class="track-filter">
                <el-radio-group v-model="filterType" @change="filterTypeChange">
                    <el-radio-button label="day">天</el-radio-button>
                    <el-radio-button label="hour">小时</el-radio-button>
                </el-radio-group>
            </div>
            <lineChart height="380px" id="website-track-charts" v-if="Object.keys(trackChartData).length > 0"
                       :chartData="trackChartData"></lineChart>
            <div v-else class="line-chart-nodata"> 暂无相关数据</div>
        </div>

        <div class="module-item-style">
            <div class="module-item-title-border-left">访问轨迹列表</div>
            <el-table
                    :data="tableData"
                    stripe
                    :header-cell-style="{background:'#f2f2f2'}"
                    style="border: 1px solid #ebeef5;margin-top: 20px;">
                <el-table-column
                        label="来源">
                    <template slot-scope="scope">
                        <span class="url-style" @click="tableFilter(scope.row.track_url_source)" v-if="checkUrl(scope.row.track_url_source)">{{
                            scope.row.track_url_source
                            }}</span>
                        <a class="url-style" :href="scope.row.track_url_source" target="_blank" v-else>{{ scope.row.track_url_source
                            }}</a>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="visitors_num"
                        label="访客数">
                </el-table-column>
                <el-table-column
                        prop="visits_num"
                        label="访问数量">
                </el-table-column>
                <el-table-column
                        prop="browse_num"
                        label="浏览量">
                </el-table-column>
                <el-table-column
                        prop="avg_browse_pagenum"
                        label="平均浏览页数">
                </el-table-column>
            </el-table>

            <!--    分页-->

            <pagenations
                    :total="total"
                    :size="postParams.pageSize"
                    @pageHandler="pageOperate">
            </pagenations>
        </div>
    </div>
</template>

<script>
    import lineChart from '@/components/echarts/line-charts'
    import TableBox from '@/components/table/table'
    import pagenations from '@/components/pagenations/pagenations'

    export default {
        name: 'report-website',
        components: {
            lineChart,
            TableBox,
            pagenations
        },
        data() {
            return {
                selectTime: '',
                popoverVisible: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
                    }
                },
                filterType: 'day',
                tableData: [],
                total: 0,

                trackData: {},
                trackChartData: {},
                postParams: {
                    source: 'normal',
                    startTime: '',// 开始时间戳
                    endTime: '',// 结束时间戳(可以不传,不传的时候查今天的)
                    trackUrl: '',// 来源
                    addrIds: [],// 城市地址id集合
                    pageNum: 1,// 分页页数
                    pageSize: 10,
                }, //normal和searchEngin,
                treeData:[],
                checkedAddrName:'点击选择地址'
            }
        },
        mounted() {
            this.websiteTrackReport()
            this.getAddr()
        },
        methods: {
            /**
             * 表单操作
             * @param val
             */
            handleOperate(val) {
                console.log('val=', val)
            },
            /**
             *  分页操作
             * @param val
             */
            pageOperate(val) {
                if (val.type == 'currentChange') {
                    this.postParams.pageNum = val.val
                } else if (val.type == "sizeChange") {
                    this.postParams.pageSize = val.val
                }
                this.websiteTrackReport()
            },
            checkUrl(url){
                let reg = /^(http[^"]*)/g
                if(!reg.test(url)){
                    return true
                }else {
                    return  false
                }
            },
            /**
             * 时间选择
             */
            timeSelect() {
                if(this.selectTime){
                    this.postParams.startTime = this.selectTime[0] / 1000
                    let endTime = this.selectTime[1] / 1000
                    this.postParams.endTime = endTime + 24 * 60 * 60 - 1
                }else {
                    this.postParams.startTime = ''
                    this.postParams.endTime = ''
                }
                this.$nextTick(() => {
                    this.websiteTrackReport()
                })
            },
            /**
             * 获取轨迹数据
             */
            websiteTrackReport() {
                this.$http.websiteTrackReportAPI(this.postParams).then(res => {
                    if (res.status == 1) {
                        let dayData = res.data[this.filterType]
                        this.renderChart(dayData, this.filterType)
                        this.trackData = res.data
                        this.tableData = res.data.list.reportData
                        this.total = res.data.list.total
                    }
                })
            },
            renderChart(data, type) {
                this.trackChartData = {}
                let names = []; //类别数组（实际用来盛放X轴坐标值）
                let series1 = [];
                let series2 = [];
                let series3 = [];

                if (type == 'hour') {
                    data.map(item => {
                        names.push(item.track_time + '点')
                    })
                }
                if (type == 'day') {
                    data.map(item => {
                        names.push(item.track_time + '日')
                    })
                }
                data.map(item => {
                    series1.push(item.visitors_num)
                })
                data.map(item => {
                    series2.push(item.visits_num)
                })
                data.map(item => {
                    series3.push(item.browse_num)
                })
                let obj = {
                    time: {
                        data: names
                    },
                    visitors_num: {
                        data: series1,
                        name: '访客数'
                    },
                    visits_num: {
                        data: series2,
                        name: '访问量'
                    },
                    browse_num: {
                        data: series3,
                        name: '浏览量'
                    },
                }
                setTimeout(() => {
                    this.trackChartData = obj
                }, 0)

            },
            /**
             * 按天-小时筛选
             */
            filterTypeChange() {
                let type = this.filterType
                let renderData = this.trackData[type]
                this.$nextTick(() => {
                    this.renderChart(renderData, type)
                })

            },
            getAddr(){
                this.$http.websiteGetAddrAPI().then( res => {
                    if(res.status == 1){
                        let addrData = res.data
                        let newAddrTree = []
                        // 将后台返回的数据转换成Element tree所需的数据格式
                        addrData.map(item => {
                            let levelOne = {}
                            levelOne.id = item.province_id
                            levelOne.label = item.province_name
                            levelOne.children = []
                            item.city.map( child => {
                                let levelTwo = {}
                                levelTwo.id = child.city_id
                                levelTwo.label = child.city_name
                                levelOne.children.push(levelTwo)
                            })
                            newAddrTree.push(levelOne)
                        })

                        this.treeData = newAddrTree
                    }
                })
            },
            tableFilter(url){
                this.postParams.trackUrl = url
                this.websiteTrackReport()
            },
            chooseAddr() {
                let checkedNode = this.$refs.tree.getCheckedNodes()
                let checkedIds = this.$refs.tree.getCheckedKeys()
                if(checkedIds.length == 0){
                    return false
                }
                this.popoverVisible = false
                this.postParams.addrIds = checkedIds
                let addrName = []
                checkedNode.map( item => {
                    addrName.push(item.label)
                })
                this.checkedAddrName = addrName.join('、')
                this.websiteTrackReport()
            },
        }
    }
</script>

<style lang="scss">
    .report-website {
        .track-filter {
            padding-top: 20px;
        }
        .url-style{
            color: $mainColor;
            cursor: pointer;
        }
        .website-addr-container{
            width:160px;
            height:40px;
            background:rgba(255,255,255,1);
            border:1px solid rgba(224, 224, 224, 1);
            border-radius:6px;
            margin-left: 30px;
            line-height: 40px;
            text-align: center;
            position: relative;
            .addr-text{
                color: #999;
                cursor: pointer;
                height: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 0 5px;
            }
        }
    }
    .addr-tree-container{
        overflow: auto;
        width: 211px;
        display: flex;
        flex-direction: column;
        margin: 0 -12px -12px;
        .addr-tree{
            height: 240px;
            overflow: auto;
            padding: 0 12px;
        }
        .comfirm-btn{
            flex: 1;
            background-color: $mainColor;
            text-align: center;
            color: #fff;
            line-height: 30px;
            cursor: pointer;
        }
    }
</style>
